module.exports = __webpack_public_path__ + "img/img_47.a9d6ddc2.png";